module.exports = __webpack_public_path__ + "static/media/Erin Dang.c004945e.png";